export const bronze = {
  1: { value: { base: '{colors.bronze.light.1}', _dark: '{colors.bronze.dark.1}' } },
  2: { value: { base: '{colors.bronze.light.2}', _dark: '{colors.bronze.dark.2}' } },
  3: { value: { base: '{colors.bronze.light.3}', _dark: '{colors.bronze.dark.3}' } },
  4: { value: { base: '{colors.bronze.light.4}', _dark: '{colors.bronze.dark.4}' } },
  5: { value: { base: '{colors.bronze.light.5}', _dark: '{colors.bronze.dark.5}' } },
  6: { value: { base: '{colors.bronze.light.6}', _dark: '{colors.bronze.dark.6}' } },
  7: { value: { base: '{colors.bronze.light.7}', _dark: '{colors.bronze.dark.7}' } },
  8: { value: { base: '{colors.bronze.light.8}', _dark: '{colors.bronze.dark.8}' } },
  9: { value: { base: '{colors.bronze.light.9}', _dark: '{colors.bronze.dark.9}' } },
  10: { value: { base: '{colors.bronze.light.10}', _dark: '{colors.bronze.dark.10}' } },
  11: { value: { base: '{colors.bronze.light.11}', _dark: '{colors.bronze.dark.11}' } },
  12: { value: { base: '{colors.bronze.light.12}', _dark: '{colors.bronze.dark.12}' } },
  a1: { value: { base: '{colors.bronze.light.a1}', _dark: '{colors.bronze.dark.a1}' } },
  a2: { value: { base: '{colors.bronze.light.a2}', _dark: '{colors.bronze.dark.a2}' } },
  a3: { value: { base: '{colors.bronze.light.a3}', _dark: '{colors.bronze.dark.a3}' } },
  a4: { value: { base: '{colors.bronze.light.a4}', _dark: '{colors.bronze.dark.a4}' } },
  a5: { value: { base: '{colors.bronze.light.a5}', _dark: '{colors.bronze.dark.a5}' } },
  a6: { value: { base: '{colors.bronze.light.a6}', _dark: '{colors.bronze.dark.a6}' } },
  a7: { value: { base: '{colors.bronze.light.a7}', _dark: '{colors.bronze.dark.a7}' } },
  a8: { value: { base: '{colors.bronze.light.a8}', _dark: '{colors.bronze.dark.a8}' } },
  a9: { value: { base: '{colors.bronze.light.a9}', _dark: '{colors.bronze.dark.a9}' } },
  a10: { value: { base: '{colors.bronze.light.a10}', _dark: '{colors.bronze.dark.a10}' } },
  a11: { value: { base: '{colors.bronze.light.a11}', _dark: '{colors.bronze.dark.a11}' } },
  a12: { value: { base: '{colors.bronze.light.a12}', _dark: '{colors.bronze.dark.a12}' } },
}
